var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('LayoutBanner',{key:_vm.preExamCategory,attrs:{"preExamCategory":_vm.preExamCategory}}),_c('div',{staticClass:"box right con"},[_c('LayoutTagTitle',[_vm._v("歷屆考題下載")]),_c('CAPDownloadList')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }